  export const getCSVRow = (items: string[]): string => {
    return items
    .map( s => String( s ) )
    .map(s => {
      return '"' + s?.replaceAll('"', '""') + '"';
    }).join(',');
  }
